import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_BASE_NAME } from './constants';
import type { Sector } from '@/types/data';

export type SectorsState = {
    sectors: Sector[];
    isLoading: boolean;
    error: string | null;
}

const initialState: SectorsState = {
    sectors: [],
    isLoading: false,
    error: null,
};

const sectorsSlice = createSlice({
    name: `${SLICE_BASE_NAME}/sector`,
    initialState,
    reducers: {
        setSectors: (state, action: PayloadAction<Sector[]>) => {
            state.sectors = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const { setSectors, setLoading, setError } = sectorsSlice.actions;

export default sectorsSlice.reducer;
